import { IKeyValue } from "motw_core/Entity/IKeyValue";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { ChangeEnergy } from "source/app/presentation/BottomBar/BottomLeftDashboard/Energy/Change/ChangeEnergy";
import {
    IKeyboardEvent,
    TKeyboardEvent,
} from "source/app/services/UI/KeyboardEvents/IKeyboardEvents";
import { ReadState } from "../../../State/ReadState";

export const IncreaseEnergy: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + Up`,
    actionDescription: `Increase energy`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && !event.shiftKey && event.keyCode == 38,
    action: () => {
        const currentEnergy = Number.parseInt(
            ReadState<IKeyValue>(
                ESharedFunction.ShowCurrentEnergy_currentValue
            )!.value
        );

        if (currentEnergy >= 6) {
            return;
        }

        const newEnergy = currentEnergy + 1;
        ChangeEnergy(newEnergy);
    },
};

export const ReduceEnergy: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + Down`,
    actionDescription: `Reduce energy`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && !event.shiftKey && event.keyCode == 40,
    action: () => {
        const currentEnergy = Number.parseInt(
            ReadState<IKeyValue>(
                ESharedFunction.ShowCurrentEnergy_currentValue
            )!.value
        );

        if (currentEnergy <= 1) {
            return;
        }

        const newEnergy = currentEnergy - 1;
        ChangeEnergy(newEnergy);
    },
};
